import {Colors} from '@constants/colors.constants';
import {Button, Stack, styled, Typography} from '@mui/material';
import {ProposalSupplierActivities, StatusActivity} from '@store/audits/audit-offer-followUp/audit-offer-followUp.model';
import {OfferFollowUpDetailsRoutes} from '@utils/routes.utils';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import ActivityLogoItem from './ActivityLogo';
import dayjs from 'dayjs';


const ActivityItemStyled = styled(Stack)({
  width: '100%',
  alignItems: 'center',
  justifyContent: 'space-between',
});

interface ActivityItemProps {
  item: ProposalSupplierActivities;
}

const ActivityItem = (props: ActivityItemProps) => {
  const { item } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  // const StatusView = item.validatedAt ? <OfferTagItem tagStatus={OfferStatusEnum.VALIDATE} /> :
  //   item.answeredAt ? <OfferTagItem tagStatus={OfferStatusEnum.ANSWERED} /> :
  //     item.sentAt ? <OfferTagItem tagStatus={OfferStatusEnum.WAITING} /> : null;

  return (
    <ActivityItemStyled direction={'row'}>
      <Stack direction={'row'} alignItems={'center'} spacing={2}>
        <ActivityLogoItem logoStatus={item.type} />
        <Stack>
          <Typography sx={{ color: Colors.black, fontWeight: 500, fontSize: '15px' }}>
            {item.type === StatusActivity.VALIDATED && t('audits.auditOfferFollowUp.historyOffer.processed', { partner: item.supplierOrganisationUnitName, proposal: item.auditProposalName })}
            {item.type === StatusActivity.ANSWERED && t('audits.auditOfferFollowUp.historyOffer.received', { partner: item.supplierOrganisationUnitName, proposal: item.auditProposalName })}
            {item.type === StatusActivity.SENT && t('audits.auditOfferFollowUp.historyOffer.sent', { partner: item.supplierOrganisationUnitName, proposal: item.auditProposalName })}
          </Typography>
          <Typography sx={{ fontWeight: 400, fontSize: '12px', color: Colors.lightGrey }}>
            {t('audits.auditOfferFollowUp.historyOffer.emissionDate', { date: dayjs(item.date).format('DD.MM.YY') })}
          </Typography>
        </Stack>
      </Stack>
      <Button variant="outlined" color="primary" sx={{ padding: '6px 8px' }} onClick={() => navigate(`${OfferFollowUpDetailsRoutes.DETAILS_OFFERSTATUS}/${item.auditProposalSupplierId}`)}>
        <Typography fontSize='14px' fontWeight={400}>
          {t('audits.auditOfferFollowUp.historyOffer.buttons.seeDetail')}
        </Typography>
      </Button>
    </ActivityItemStyled>
  );
};

export default ActivityItem;
